import * as React from "react"
import {ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import { IconSeeker } from "@components/ui"

import {useActiveLink} from "../../../../../../@hooks";
import {MaximalLayoutNavMiniItemStyles, MaximalLayoutNavMiniArrow, MaximalLayoutNavMiniIconStyles} from "./styles";


export default function MaximalLayoutNavMiniItem({ path, title, icon, hasChildren=false, active: activeProp, sx={} }) {
    const theme = useTheme()
    const { active: linkActive } = useActiveLink(path, hasChildren)
    // Group icons have no `path`; their active state is supplied by the NavList
    // (true when any child route matches the current location).
    const active = activeProp ?? linkActive

    const textConfig = {
        noWrap: true,
        sx: {
            width: 72,
            fontSize: 10,
            lineHeight: '16px',
            textAlign: 'center',
            ...(active && {
                fontWeight: 'fontWeightMedium'
            })
        }
    }

    const sxBtn = MaximalLayoutNavMiniItemStyles(active, hasChildren, theme)
    return <ListItemButton sx={{ ...sxBtn, ...sx.button }}>
        <ListItemIcon sx={{ ...MaximalLayoutNavMiniIconStyles, ...sx.icon }}>
            <IconSeeker  icon={icon} />
        </ListItemIcon>

        <ListItemText primary={title} primaryTypographyProps={textConfig} />

        { hasChildren && <IconSeeker icon="chevron-right" sx={MaximalLayoutNavMiniArrow} /> }
    </ListItemButton>
}